import { Box, CircularProgress, TablePagination } from '@mui/material'
import { useCallback } from 'react'
import { useQueryLabelMasters } from 'src/features/labelMaster/api/useQueryLabelMasters'
import { LabelMasterTable } from './LabelMasterTable/LabelMasterTable'

const rowsPerPageOptions = [25, 50, 100]

type Query = {
  keywords: string[]
  limit: number
  offset: number
}

type Props = {
  query: Query
  page: number
  rowsPerPage: number
  onChangePage: (newPage: number) => void
  onChangeRowsPerPage: (limit: number) => void
}

export const LabelMasterList = ({
  query,
  page,
  rowsPerPage,
  onChangePage,
  onChangeRowsPerPage,
}: Props) => {
  const { data, isLoading } = useQueryLabelMasters(query)

  const labelMasters = data?.labelMasters ?? []
  const totalCount = data?.totalCount ?? 0

  const handleChangePage = useCallback(
    (_: unknown, newPage: number) => onChangePage(newPage),
    [onChangePage],
  )

  const handleChangeRowsPerPage = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      onChangeRowsPerPage(Number(event.target.value)),
    [onChangeRowsPerPage],
  )

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <>
      <Box sx={{ minHeight: 0, overflow: 'auto' }}>
        <LabelMasterTable labelMasters={labelMasters} />
      </Box>

      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        labelRowsPerPage="1ページあたり："
        labelDisplayedRows={({ from, to, count }) =>
          `${from}〜${to} (${count !== -1 ? count : '不明'} 件中)`
        }
        sx={{
          '& .MuiTablePagination-selectLabel': {
            margin: 0,
          },
          '& .MuiTablePagination-displayedRows': {
            margin: 0,
          },
        }}
      />
    </>
  )
}
